import { Box, display, Stack } from "@mui/system";
import CompaniesNavbar from "./CompaniesNavbar";
import { Avatar, Button, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import VerifiedIconJobDetails from "../../UI/VerifiedIconJobDetails";
import SaveJobIcon from "../../UI/SaveJobIcon";
import ShareIconJobDetails from "../../UI/ShareIconJobDetails";
import ExperienceIconJobDetails from "../../UI/ExperienceIconJobDetails";
import JobBagJobDetailsIcon from "../../UI/JobBagJobDetailsIcon";
import JobClosedIconJobDetails from "../../UI/JobClosedIconJobDetails";
import Search from "@mui/icons-material/Search";
import SearchIconJobDetails from "../../UI/SearchIconJobDetails";
const jobDetailsNavbarButtons = [
  { text: "Home", route: "" },
  { text: "Jobs", route: "" },
  { text: "Information", route: "" },
];
const featuredCardsData = [
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/moneyIconWhite.svg",
    text: "80,000 - 100,000 per year",
  },
];
const chipHeadlines = [
  { text: "Information Technology" },
  { text: "Full Time" },
  { text: "Urgently Needed" },
];
const jobOverviewChipHeadlines = [
  { text: "Web Development" },
  { text: "User Interface Design" },
  { text: "Front-End Development" },
  { text: "HTML" },
  { text: "CSS" },
];
const jobRequirementsData = [
  {
    text: "Bachelor's degree in Computer Science, Web Development or related field",
  },
  { text: "3+ years of experience in web development" },
  {
    text: "Strong knowledge of front-end development languages and frameworks, including HTML, CSS, and JavaScript",
  },
  { text: "Experience with responsive design and mobile-first development" },
  { text: "Experience with version control systems, such as Git" },
  { text: "Understanding of web performance optimization techniques" },
  { text: "Strong problem-solving and analytical skills" },
  { text: "Ability to work collaboratively in a team environment" },
];
const jobOverviewData = [
  {
    icon: JobBagJobDetailsIcon,
    iconWidthAndHeight: "46",
    primaryText: "Career Level",
    secondaryText: "Mid-Level",
  },
  {
    icon: SearchIconJobDetails,
    iconWidthAndHeight: "40",
    primaryText: "Qualification:",
    secondaryText:
      "Bachelor's degree in Computer Science, Web Development or related field",
  },
  {
    icon: ExperienceIconJobDetails,
    iconWidthAndHeight: "46",
    primaryText: "Years of Experience:",
    secondaryText: "3+ years of experience in Web Development",
  },
  {
    icon: JobClosedIconJobDetails,
    iconWidthAndHeight: "46",
    primaryText: "Job Closed in:",
    secondaryText: "May 9, 2023",
  },
];
const companyOverviewData = [
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/averageIconJobDetails.svg",
    text: "Average 1-2 weeks",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/employeeIconDarkModeUnActive.svg",
    text: "50-100 employees",
  },
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/jobOpenIcon.svg",
    text: "Web Design & Development",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/moneyIconWhite.svg",
    text: "80,000 - 100,000 per year",
  },
];
function JobDetails() {
  const [activeIndux, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const [saveJob, setSaveJob] = useState(false);
  const [shareJob, setShareJob] = useState(false);
  return (
    <Stack>
      <CompaniesNavbar />
      <Stack sx={{ bgcolor: "#1c1c1c" }}>
        <Box
          sx={{
            // backgroundImage: `url(/images/desert-pattern.jpeg)`,
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            // backgroundRepeat: "no-repeat",
            // //   width: "245px",
            // height: "231px",
            display: "flex",
            position: "relative",
            // mb: "90px",
            bgcolor: "#D9D9D9",
            border: "none",
            cursor: "pointer",
            flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
            px: "100px",
            py: "100px",
            pb: "120px",
          }}
        >
          <Stack direction="row" sx={{}}>
            {jobDetailsNavbarButtons.map((btn, i) => {
              const isActive = i === activeIndux;
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <Button
                    variant="text"
                    sx={{
                      color: "#0E0B33",
                      textTransform: "none",
                      px: "20px",
                      fontWeight: isActive ? "700" : "500",
                      fontFamily: "Inter",
                      pl: i === 0 ? "0px" : "20px",
                    }}
                    onClick={() => {
                      setActiveIndex(i);
                      navigate(btn.route);
                    }}
                  >
                    {btn.text}
                  </Button>
                  {i !== jobDetailsNavbarButtons.length - 1 && " / "}
                </Box>
              );
            })}
          </Stack>
          <Typography
            variant="h1"
            sx={{ fontSize: "50px", fontWeight: "700", maxWidth: "400px" }}
          >
            Front-End Web Developer
          </Typography>
          <Avatar
            // src={}
            alt="Profile Picture"
            sx={{
              width: 160,
              height: 160,
              objectFit: "cover",
              //   border: "9px solid #ffffff",
              position: "absolute",
              bottom: -75,
              ml: "18px",
              // mb: "-50px",
              bgcolor: "#F9F9F9",
              color: "#F9F9F9",
              justifySelf: "start",
              alignSelf: "start",
              left: 80,
              borderRadius: "20px",
            }}
          ></Avatar>
        </Box>
        <Stack
          direction={"row"}
          sx={{ px: "100px", justifyContent: "space-between" }}
        >
          <Stack sx={{ width: "60%", mt: "90px" }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "700",
                fontSize: "32px",
                lineHeight: "23px",
                fontFamily: "Inter",
                textAlign: "start",
                color: "#ffffff",
                py: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              UXLabs Company
              <VerifiedIconJobDetails />
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "30px",
                pt: "4px",
              }}
            >
              {" "}
              {featuredCardsData.map((data) => (
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    gap: "6px",
                    pt: "0px",
                    justifyContent: "start",
                  }}
                >
                  <Box
                    component="img"
                    src={data.iconSrcDarkMode}
                    sx={{ width: "15px", height: "15px" }}
                  ></Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "24px",
                      fontFamily: "Inter",
                      color: "#c9c9c9",
                      textAlign: "center",
                    }}
                  >
                    {data.text}
                  </Typography>
                </Stack>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                maxWidth: "270px",
                flexWrap: "wrap",
                py: "20px",
              }}
            >
              {chipHeadlines.map((chip) => (
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "700",
                    fontSize: "12px",
                    lineHeight: "26px",
                    fontFamily: "Inter",
                    textAlign: "start",
                    color: "#ffffff",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",

                    bgcolor: "#333333",
                    borderRadius: "6px",
                    maxWidth: "max-content",
                    py: "2px",
                    px: "18px",
                  }}
                >
                  {chip.text}
                </Typography>
              ))}
            </Box>
            <Box id="job-description" sx={{ pb: "30px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "40px",
                  lineHeight: "23px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  py: "10px",
                }}
              >
                Job Description
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "20px",
                  lineHeight: "30px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#c6c6c6",
                  py: "10px",
                }}
              >
                UXLabs Company is seeking an experienced Front-End Web Developer
                to join our team. In this role, you will be responsible for
                developing and implementing user interfaces for web applications
                using HTML, CSS, and JavaScript. You will work closely with the
                design and development teams to create visually appealing and
                user-friendly web pages that meet our clients' needs.
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "700",
                fontSize: "40px",
                lineHeight: "23px",
                fontFamily: "Inter",
                textAlign: "start",
                color: "#ffffff",
                py: "30px",
              }}
            >
              Job Requirements
            </Typography>
            <Box
              id="job-requirements-description"
              sx={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "start",
                // gap: "6px",
              }}
            >
              {jobRequirementsData.map((job) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "start",
                    gap: "14px",
                  }}
                >
                  {" "}
                  <Box
                    sx={{
                      minWidth: "8px",
                      minHeight: "8px",
                      bgcolor: "#c6c6c6",
                      borderRadius: "50%",
                      mt: "11px",
                    }}
                  ></Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "400",
                      fontSize: "20px",
                      lineHeight: "30px",
                      fontFamily: "Inter",
                      textAlign: "start",
                      color: "#c6c6c6",
                      maxWidth: "950px",
                    }}
                  >
                    {job.text}
                  </Typography>
                </Box>
              ))}
              <Stack
                sx={{ bgcolor: "#262626", p: "20px", borderRadius: "26px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <Avatar
                    // src={}
                    alt="Profile Picture"
                    sx={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      ml: "18px",
                      bgcolor: "#F9F9F9",
                      color: "#F9F9F9",
                      borderRadius: "10px",
                    }}
                  ></Avatar>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "700",
                      fontSize: "32px",
                      lineHeight: "23px",
                      fontFamily: "Inter",
                      textAlign: "start",
                      color: "#ffffff",
                      py: "10px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    UXLabs Company
                    <VerifiedIconJobDetails />
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    // gap: "30px",
                    pt: "4px",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    pt: "20px",
                    gap: "4px",
                  }}
                >
                  {" "}
                  {companyOverviewData.map((data, i) => (
                    <Stack
                      direction="row"
                      sx={{
                        alignItems: "center",
                        gap: "6px",
                        pt: "0px",
                        justifyContent: "start",
                        width: "40%",
                      }}
                    >
                      <Box
                        component="img"
                        src={data.iconSrcDarkMode}
                        sx={{ width: "15px", height: "15px" }}
                      ></Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "24px",
                          fontFamily: "Inter",
                          color: "#c9c9c9",
                          textAlign: "center",
                        }}
                      >
                        {data.text}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Stack>
            </Box>
          </Stack>
          <Stack id="job-overview" sx={{ mt: "30px" }}>
            {" "}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  lineHeight: "28px",
                  fontFamily: "Inter",
                  textAlign: "right",
                  color: "#c6c6c6",
                }}
              >
                Posted February 10, 2023
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  lineHeight: "28px",
                  fontFamily: "Inter",
                  textAlign: "right",
                  color: "#c6c6c6",
                }}
              >
                Last activity 3 days ago
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                py: "24px",
              }}
            >
              <Button
                sx={{
                  fontSize: "16px",
                  lineHeight: "22px",
                  color: "#FFFFFF",
                  py: "15px",
                  textTransform: "none",
                  bgcolor: "#000000",
                  borderRadius: "10px",
                  px: "80px",
                }}
              >
                Apply This Job
              </Button>
              <IconButton
                sx={{
                  border: "1px solid #ffffff",
                  py: "14px",
                  px: "20px",
                  borderRadius: "10px",
                  bgcolor: "transparent",
                  "&:hover": {
                    bgcolor: "transparent",
                  },
                  "&:active": {
                    bgcolor: "transparent", // Prevents active (click) background color
                  },
                }}
                onClick={() => setSaveJob(!saveJob)}
              >
                <SaveJobIcon
                  color="#ffffff"
                  fill={`${saveJob ? "#ffffff" : "none"}`}
                  width="22"
                  height="22"
                />
              </IconButton>
              <IconButton
                sx={{
                  border: "1px solid #ffffff",
                  py: "14px",
                  px: "20px",
                  borderRadius: "10px",
                  bgcolor: "transparent",
                  "&:hover": {
                    bgcolor: "transparent",
                  },
                  "&:active": {
                    bgcolor: "transparent", // Prevents active (click) background color
                  },
                }}
                onClick={() => setShareJob(!shareJob)}
              >
                <ShareIconJobDetails
                  color="#ffffff"
                  fill={`${saveJob ? "#ffffff" : "none"}`}
                  width="22"
                  height="22"
                />
              </IconButton>
            </Box>
            <Stack sx={{ bgcolor: "#262626", p: "40px", borderRadius: "26px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "40px",
                  lineHeight: "23px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  py: "10px",
                }}
              >
                Job overview
              </Typography>
              <Stack direction="column" sx={{ gap: "30px", py: "40px" }}>
                {jobOverviewData.map((overview) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "25px",
                      alignItems: "start",
                    }}
                  >
                    <overview.icon
                      iconWidthAndHeight={overview.iconWidthAndHeight}
                    />
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "22px",
                          fontFamily: "Inter",
                          textAlign: "start",
                          color: "#ffffff",
                          pb: "4px",
                        }}
                      >
                        {overview.primaryText}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "400",
                          fontSize: "18px",
                          lineHeight: "22px",
                          fontFamily: "Inter",
                          textAlign: "start",
                          color: "#ffffff",
                          maxWidth: "280px",
                        }}
                      >
                        {overview.secondaryText}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Stack>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "18px",
                  lineHeight: "22px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  pb: "4px",
                }}
              >
                Skills Specialization:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  flexWrap: "wrap",
                  pt: "10px",
                  maxWidth: "335px",
                }}
              >
                {jobOverviewChipHeadlines.map((chip) => (
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "700",
                      fontSize: "12px",
                      lineHeight: "26px",
                      fontFamily: "Inter",
                      textAlign: "start",
                      color: "#ffffff",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      bgcolor: "#333333",
                      borderRadius: "6px",
                      maxWidth: "max-content",
                      py: "2px",
                      px: "18px",
                    }}
                  >
                    {chip.text}
                  </Typography>
                ))}
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default JobDetails;
